'use strict';

import cleanUrl from './cleanUrl';
import footerCats from './footerCats';
import max from './max';
import min from './min';

export const legacyfilters = angular.module('legacy.filters', [])
    .filter('cleanUrl', cleanUrl)
    .filter('footerCats', footerCats)
    .filter('max', max)
    .filter('min', min);

export default legacyfilters;
